import React from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { TaxonomyTheme } from '../../../../../types/uncinc_profile/taxonomy';
import TaxonomyThemeCardParent from '../../Card/Parent';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaserParent: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const langcode = theme.langcode[0].value;
  const url = theme.paths[langcode];
  const title = theme.name[0].value;
  const { icon, family: iconFlair } = theme.field_icon[0] || {};
  const colorClass = theme.field_labels[0]?.entity.field_icon[0]?.classes ?? 'u-background--secondary--400';
  const classes = c('TaxonomyThemeTeaser', 'TaxonomyThemeTeaser--Parent', colorClass);

  return (
    <TaxonomyThemeCardParent
      className={classes}
      url={url}
      title={title}
      icon={icon}
      iconFlair={iconFlair === 'baseline' ? 'filled' : iconFlair}
    />
  );
};

export default TaxonomyThemeTeaserParent;
